import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class CompanyExternalLink extends RestApiModel {

  static getResourceEndpoint() {
    return '/companies/external-links';
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

}

export default CompanyExternalLink;
